import DuckEntity from './DuckEntity';

const duck = new DuckEntity('delayedJobs');

const reducer = (state = duck.initialState, action) => {
  switch (action.type) {
    case duck.types.LOAD_SUCCESS:
      const {
        payload: {
          result: {
            meta: {
              failed_count: failedCount,
              queue_summaries: queueSummaries
            }
          }
        }
      } = action;

      const result = {
        ...duck.reducer(state, action)
      };

      result[action.stateKey].failedCount = failedCount;
      result[action.stateKey].queueSummaries = queueSummaries;

      return result;
    default:
      return duck.reducer(state, action);
  }
};

const all = (state, stateKey = '_all') => {
  const result = duck.all(state, stateKey);

  if (state[duck.name][stateKey]) {
    const { failedCount, queueSummaries } = state[duck.name][stateKey];

    result.failedCount = failedCount || 0;
    result.queueSummaries = queueSummaries || {};
  } else {
    result.failedCount = 0;
    result.queueSummaries = {};
  }

  return result;
};

export const entity = {
  ...duck,
  reducer,
  all
};
